import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { META_REDUCERS, StoreModule } from '@ngrx/store';
import { ConfigModule, ProcessModule, StateConfig, StateTransferType } from '@spartacus/core';
import { ProductPersistenceService } from './product-persistence.service';
import { PRODUCT_FEATURE } from './product-state';
import { reducerProvider, reducerToken, resetProductFactory } from './reducers';

function productStatePersistenceFactory(productPersistenceService: ProductPersistenceService): () => void {
  return () => productPersistenceService.sync();
}

function productStoreConfigFactory(): StateConfig {
  return {
    state: {
      ssrTransfer: {
        keys: {
          [PRODUCT_FEATURE]: StateTransferType.TRANSFER_STATE,
        },
      },
    },
  };
}

@NgModule({
  imports: [
    ProcessModule.forRoot(),
    StoreModule.forFeature(PRODUCT_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(productStoreConfigFactory),
  ],
  providers: [
    reducerProvider,
    {
      provide: META_REDUCERS,
      useFactory: resetProductFactory,
      multi: true,
    },
    provideAppInitializer(() => {
      const initializerFn = productStatePersistenceFactory(inject(ProductPersistenceService));

      return initializerFn();
    }),
  ],
})
export class ProductStoreModule {}
